import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'
// 发送验证码
export function liBaiSendCaptcha(data) {
  return request({
    url: `${apiConfig.ZY}/liBai/sendCaptcha`,
    method: 'post',
    hideErrorToast: true,
    data
  })
}
// 登录
export function liBaiLogin(data) {
  return request({
    url: `${apiConfig.ZY}/liBai/login`,
    method: 'post',
    data
  })
}
// 领取
export function liBaiReceive(data) {
  return request({
    url: `${apiConfig.ZY}/liBai/receive`,
    method: 'post',
    token: sessionStorage.getItem('liBaiToken'),
    hideErrorToast: true,
    data
  })
}
// 详情
export function liBaiReceiveOrder(data) {
  return request({
    url: `${apiConfig.ZY}/liBai/getReceiveOrder`,
    method: 'post',
    token: sessionStorage.getItem('liBaiToken'),
    data
  })
}
